(function () {
  function getModalContent(contentId) {
    const source = document.getElementById(contentId);
    return source ? source.innerHTML.trim() : '';
  }

  function getCartAddUrl() {
    const root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

    return root + 'cart/add.js';
  }

  function getCartUrl() {
    const root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

    return root + 'cart';
  }

  function initPoolTableOptions(wrapper) {
    if (!wrapper || wrapper.dataset.axis80Initialized === 'true') return;

    const clothTypeSelect = wrapper.querySelector('#axis80-cloth-type-select');
    const clothColorPrompt = wrapper.querySelector('#cloth-colors-choose-type-first');
    const clothColorOptions = wrapper.querySelectorAll('.axis80-color-option-value');
    const selectedColorWrap = wrapper.querySelector('.axis80-selected-color');
    const selectedColorName = wrapper.querySelector('[data-axis80-selected-color-name]');
    const errorContainer = wrapper.querySelector('[data-axis80-form-errors]');

    let isSubmitting = false;

    function getSelectedValue(selector) {
      const field = wrapper.querySelector(selector);
      return field ? field.value.trim() : '';
    }

    function getCheckedValue(selector) {
      const field = wrapper.querySelector(selector + ':checked');
      return field ? field.value.trim() : '';
    }

    function validatePoolTableOptions() {
      const errors = [];

      if (clothTypeSelect && !getSelectedValue('#axis80-cloth-type-select')) {
        errors.push('Please select a cloth type.');
      }

      if (clothTypeSelect && !getCheckedValue('input[name="cloth-color"]')) {
        errors.push('Please select a cloth color.');
      }

      if (!getSelectedValue('#axis80-play-package-select')) {
        errors.push('Please select a play package.');
      }

      if (!getSelectedValue('#axis80-pingpongtop-select')) {
        errors.push('Please select a ping pong conversion top.');
      }

      return errors;
    }

    function showErrors(errors) {
      if (!errorContainer) {
        alert('Please correct the following:\n\n' + errors.join('\n'));
        return;
      }

      errorContainer.innerHTML = `
        <p>Please correct the following:</p>
        <ul>
          ${errors.map((error) => `<li>${error}</li>`).join('')}
        </ul>
      `;

      errorContainer.hidden = false;
      errorContainer.focus();
    }

    function clearErrors() {
      if (!errorContainer) return;

      errorContainer.hidden = true;
      errorContainer.innerHTML = '';
    }

    function getAddonVariantIds() {
      const variantIds = [];

      const clothColorId = getCheckedValue('input[name="cloth-color"]');
      if (clothColorId) {
        variantIds.push(clothColorId);
      }

      const playPackageId = getSelectedValue('#axis80-play-package-select');
      if (playPackageId && playPackageId !== 'none') {
        variantIds.push(playPackageId);
      }

      const pingPongTopId = getSelectedValue('#axis80-pingpongtop-select');
      if (pingPongTopId && pingPongTopId !== 'none') {
        variantIds.push(pingPongTopId);
      }

      return variantIds;
    }

    function resetSelectedColorName(showStatus) {
      if (selectedColorWrap && selectedColorName) {
        selectedColorName.textContent = 'Not selected';
        selectedColorWrap.hidden = !showStatus;
      }
    }

    function updateClothColors() {
      if (!clothTypeSelect) return;

      const selectedClothType = clothTypeSelect.value.trim();

      clothColorOptions.forEach((option) => {
        const input = option.querySelector('input[type="radio"]');
        const shouldShow =
          selectedClothType !== '' &&
          option.classList.contains(selectedClothType);

        option.classList.toggle('is-visible', shouldShow);
        option.hidden = !shouldShow;

        if (!shouldShow && input) {
          input.checked = false;
        }
      });

      if (clothColorPrompt) {
        clothColorPrompt.hidden = selectedClothType !== '';
      }

      resetSelectedColorName(selectedClothType !== '');
    }

    async function addItemsToCart(items) {
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.description || json.message || 'Unable to add items to cart.');
      }

      return json;
    }

    function setSubmittingState(productForm, submitting) {
      const submitButton = productForm.querySelector('[type="submit"][name="add"], [type="submit"]');

      if (!submitButton) return;

      if (!submitButton.dataset.axis80OriginalText) {
        submitButton.dataset.axis80OriginalText = submitButton.textContent.trim();
      }

      submitButton.disabled = submitting;
      submitButton.classList.toggle('is-loading', submitting);

      submitButton.textContent = submitting
        ? 'Adding to cart...'
        : submitButton.dataset.axis80OriginalText;
    }

    function refreshThenOpenCartDrawer(opener) {
      let opened = false;

      function open() {
        if (opened) return;
        opened = true;

        document.removeEventListener('on:cart:after-merge', open);

        document.dispatchEvent(
          new CustomEvent('dispatch:cart-drawer:open', {
            bubbles: true,
            detail: { opener }
          })
        );
      }

      document.addEventListener('on:cart:after-merge', open);

      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        })
      );

      window.setTimeout(open, 1000);
    }

    function handleCartSuccess(opener) {
      document.dispatchEvent(new CustomEvent('axis80:cart:add'));

      const drawer = document.querySelector(
        'side-drawer[data-name="cart"], side-drawer[data-name="cart-drawer"], #cart-drawer'
      );

      if (!drawer) {
        window.location.href = getCartUrl();
        return;
      }

      refreshThenOpenCartDrawer(opener);
    }

    if (clothTypeSelect) {
      clothTypeSelect.addEventListener('change', updateClothColors);
      updateClothColors();
    }

    wrapper.addEventListener('change', (event) => {
      clearErrors();

      if (!event.target.matches('input[name="cloth-color"]')) return;
      if (!selectedColorWrap || !selectedColorName) return;

      selectedColorName.textContent =
        event.target.dataset.colorName ||
        event.target.getAttribute('aria-label') ||
        'Selected';

      selectedColorWrap.hidden = false;
    });

    wrapper.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !window.Axis80Modal) return;

      if (button.id === 'openModalClothType') {
        window.Axis80Modal.open(
          'Compare cloth types',
          getModalContent('axis80ClothTypesContent'),
          button
        );
      }

      if (button.id === 'openModalPlayPackages') {
        window.Axis80Modal.open(
          'Play packages',
          getModalContent('axis80PlayPackagesContent'),
          button
        );
      }

      if (button.id === 'openModalPingPongTop') {
        window.Axis80Modal.open(
          'Ping pong conversion top',
          getModalContent('axis80PingPongTopContent'),
          button
        );
      }
    });

    const productInfo = wrapper.closest('.product-info');

    const productForm =
      productInfo?.querySelector('form.js-product-form.js-product-form-main') ||
      document.querySelector('form.js-product-form.js-product-form-main');

    if (productForm) {
      productForm.addEventListener(
        'submit',
        async (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (isSubmitting) return;

          clearErrors();

          const errors = validatePoolTableOptions();

          if (errors.length) {
            showErrors(errors);
            return;
          }

          const mainVariantInput = productForm.querySelector('input[name="id"]');
          const quantityInput = productForm.querySelector('input[name="quantity"]');

          const mainVariantId = mainVariantInput ? mainVariantInput.value.trim() : '';
          const mainQuantity = quantityInput
            ? Math.max(parseInt(quantityInput.value, 10) || 1, 1)
            : 1;

          if (!mainVariantId) {
            showErrors(['Unable to determine the selected product variant.']);
            return;
          }

          const addonVariantIds = getAddonVariantIds();

          const items = [
            {
              id: Number(mainVariantId),
              quantity: mainQuantity
            },
            ...addonVariantIds.map((variantId) => ({
              id: Number(variantId),
              quantity: mainQuantity
            }))
          ];

          try {
            isSubmitting = true;
            setSubmittingState(productForm, true);

            await addItemsToCart(items);

            isSubmitting = false;
            setSubmittingState(productForm, false);
            clearErrors();
            handleCartSuccess(productForm.querySelector('[type="submit"][name="add"], [type="submit"]'));

          } catch (error) {
            console.error(error);

            showErrors([
              error.message || 'Unable to add items to cart. Please try again.'
            ]);

            isSubmitting = false;
            setSubmittingState(productForm, false);
          }
        },
        true
      );
    }

    wrapper.dataset.axis80Initialized = 'true';
    wrapper.classList.add('is-initialized');
  }

  function initAll() {
    document
      .querySelectorAll('[data-axis80-pool-table-options]')
      .forEach(initPoolTableOptions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();